<!--此页面是团体模块下团体整体的效益类下的短险综合成本率页面-->
<template>
  <div class="table">
    <el-row class="table-warpper">
      <el-col :span="12" class="table-title">机构分析</el-col>
      <!-- <el-col :span="15" class="buttonChange timeButton">
        <button :class="{ choose:1===type }" @click="changeType(1)">分公司</button>
        <button :class="{ choose:2===type }" @click="changeType(2)">百强中支</button>
      </el-col> -->
      <el-col :span="12" class="table-icon">
        <div @click="showPopup">
          <img src="../../../../static/images/screen.png" style="width:.2rem;height:.2rem">
        </div>
        <van-popup v-model="screenShow">
          <table-screens ref="screen" v-on:childByValue="childByValue" :otherFiler="nameData" :calendarData="dateData"></table-screens>
        </van-popup>
      </el-col>
    </el-row>
    <div v-if="clearTable" :class="{ 'defTable':notmore,'fixTop':isMore }">
      <el-table
        :key='key'
        ref="RateTable"
        :data="showData"
        style="width: 100%"
        row-key="id"
        :height="popHeight"
        border
        lazy
        @sort-change="sortProportion"
        :header-cell-class-name="handleTheadAddClass"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :class="{ 'tableList5': notmore,'table-itme':true }">
        <el-table-column
          :key="Math.random()"
          prop="provincecomsName"
          label="机构"
          style="width: 25%"
          sortable='custom'
          class="demo-table-expand">
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="achievementRate"
          label="实际"
          style="width: 25%"
          sortable='custom'>
          <template slot-scope="scope">
            <label v-if="scope.row.achievementRate !== null">{{ scope.row.achievementRate }}%</label>
            <label v-else>--%</label>
          </template>
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="rank"
          sortable='custom'
          label="排名"
          style="width: 25%">
          <template slot-scope="scope">
            {{ scope.row.rank }}
            <label v-if="scope.row.flag === 3">--</label>
            <span v-else>
              <span class="updown">
                <img v-if="scope.row.flag === 2" src="../../../../static/images/up.png" alt="">
                <img v-if="scope.row.flag === 1" src="../../../../static/images/down.png" alt="">
              </span>
              <span :class="{ down:1===scope.row.flag }">
                {{ scope.row.rankDiff }}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="onYearRate"
          label="同比"
          style="width: 25%"
          sortable='custom'>
          <template slot-scope="scope">
            <label v-if="scope.row.onYearRate !== null">{{ scope.row.onYearRate }}pt</label>
            <label v-else>--pt</label>
          </template>
        </el-table-column>
        <el-table-column
        :key="Math.random()"
        prop="comparedWith"
        label="跳转"
        min-width="100">
          <template slot-scope="scope">
            <label v-if="scope.row.nextLevel===2 && !scope.row.isTotalLine" @click = jumpMenoth(scope.row.comparedWith) ><img src="../../../../static/images/navigation.png" style="width:.2rem;height:.2rem"></label>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col :span="24"><div @click="showMore" class="more" v-show="countFlag">{{moreText}}</div></el-col>
      </el-row>
    </div>
    <div v-show="rightImg" class="rightImg">
      <img src="../../../../static/images/icon_more2.png" alt="">
    </div>
  </div>
</template>

<script>
import TableScreens from './screens/Screens'
// import axios from 'axios'
import { postAction } from '@/utils/api'
// eslint-disable-next-line no-unused-vars
import { getUrlKey } from '@/utils/util'
export default {
  name: 'Table',
  components: {
    TableScreens
  },
  props: ['dateData'],
  data () {
    return {
      key: 1,
      rightImg: false, // 表格指示图标状态
      type: 1,
      moreFlag: true,
      showData: [],
      moreText: '查看更多',
      screenShow: false,
      showTabledata: null,
      getTable: {},
      tableData: [],
      popHeight: '',
      firstLevel: [], // 筛选中的一级数据
      secondLevel: [], // 筛选中的二级数据
      newTableData: [], // 有层级的全部数据
      showNewTableData: [], // 筛选后的有层级的所有数据
      reachObj: null,
      compareObj: null,
      rateObj: null,
      nameData: {},
      curThead: '',
      sequenceOrder: null,
      countFlag: null,
      isMore: false, // 控制查看更多时表格样式
      notmore: true, // 控制查看更多时表格样式
      totalRow: {},
      clearTable: true
    }
  },
  methods: {
    jumpMenoth (val) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否跳转到员工看板查看该机构负责人的绩效考核情况',
        className: 'confirmStyle',
        confirmButtonText: '是',
        cancelButtonText: '否'
      })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    },
    sortProportion (column) {
      this.curThead = column.prop
      this.totalDealSortArr(column.prop, column.order)
      const data = this.$refs.RateTable.store.states.data
      const totalRowIndex = data.findIndex(row => row.id === '__total__row__')
      if (~totalRowIndex) {
        const row = data.splice(totalRowIndex, 1)
        data.unshift(row[0])
        this.$refs.RateTable.store.states.data = data
      }
    },
    // colData判断是哪一列  flagData 判断是升序还是降序
    totalDealSortArr (colData, flagData) {
      let result = JSON.parse(JSON.stringify(this.tableData))
      switch (colData) {
        case 'provincecomsName':
          // 选择机构列
          if (flagData === 'ascending') { // 升序
            // 如果机构列当前为升序状态 则把表格置为初始状态
            if (this.sequenceOrder === 'orgascending') {
              this.sequenceOrder = 'null'
              this.showData.shift()
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
              }, 200)
            } else {
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) // 升序箭头高亮
              }, 200)
              if (this.$store.state.user.level === '1') {
                result.sort((a, b) => a.provincecomCode - b.provincecomCode)
              } else {
                result[0].children.sort((a, b) => a.provincecomCode - b.provincecomCode)
              }
              this.sequenceOrder = 'orgascending' // 标志机构排序类型
            }
          } else if (flagData === 'descending') { // 降序
            // 如果机构列当前为降序状态 则把表格置为初始状态
            if (this.sequenceOrder === 'orgdescending') {
              this.sequenceOrder = 'null'
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
              }, 200)
            } else {
              setTimeout(() => {
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'}) // 降序箭头高亮
              }, 200)
              if (this.$store.state.user.level === '1') {
                result.sort((a, b) => a.provincecomCode - b.provincecomCode).reverse()
              } else {
                result[0].children.sort((a, b) => a.provincecomCode - b.provincecomCode).reverse()
              }
              this.sequenceOrder = 'orgdescending'
            }
          } else {
            this.sequenceOrder = 'null'
            setTimeout(() => {
              $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
              $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
            }, 200)
          }
          break
        case 'achievementRate':
          if (flagData === 'ascending') { // 点击升序
            // 如果达成列当前为升序状态 则把表格置为初始状态
            if (this.sequenceOrder === 'achievementascending') {
              this.sequenceOrder = 'null'
              this.showData.shift()
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
              }, 200)
            } else {
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) // 升序箭头高亮
              }, 200)
              if (this.$store.state.user.level === '1') {
                result.sort((a, b) => a.achievementRate - b.achievementRate)
              } else {
                result[0].children.sort((a, b) => a.achievementRate - b.achievementRate)
              }
              this.sequenceOrder = 'achievementascending' // 标志机构排序类型
            }
          } else if (flagData === 'descending') {
            if (this.sequenceOrder === 'achievementdescending') {
              this.sequenceOrder = 'null'
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
              }, 200)
            } else {
              setTimeout(() => {
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'})
              }, 200)
              if (this.$store.state.user.level === '1') {
                result.sort((a, b) => b.achievementRate - a.achievementRate)
              } else {
                result[0].children.sort((a, b) => b.achievementRate - a.achievementRate)
              }
              this.sequenceOrder = 'achievementdescending'
            }
          } else {
            this.sequenceOrder = 'null'
            setTimeout(() => {
              $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
              $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
            }, 200)
          }
          break
        case 'rank':
          if (flagData === 'ascending') { // 点击升序
            // 如果达成列当前为升序状态 则把表格置为初始状态
            if (this.sequenceOrder === 'achievementascending') {
              this.sequenceOrder = 'null'
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
              }, 200)
            } else {
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) // 升序箭头高亮
              }, 200)
              if (this.$store.state.user.level === '1') {
                result.sort((a, b) => a.rank - b.rank)
              } else {
                result[0].children.sort((a, b) => a.rank - b.rank)
              }
              this.sequenceOrder = 'achievementascending' // 标志机构排序类型
            }
          } else if (flagData === 'descending') {
            if (this.sequenceOrder === 'achievementdescending') {
              this.sequenceOrder = 'null'
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
              }, 200)
            } else {
              setTimeout(() => {
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'})
              }, 200)
              if (this.$store.state.user.level === '1') {
                result.sort((a, b) => b.rank - a.rank)
              } else {
                result[0].children.sort((a, b) => b.rank - a.rank)
              }
              this.sequenceOrder = 'achievementdescending'
            }
          } else {
            this.sequenceOrder = 'null'
            setTimeout(() => {
              $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
              $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
            }, 200)
          }
          break
        case 'onYearRate':
          if (flagData === 'ascending') { // 点击升序
            // 如果达成列当前为升序状态 则把表格置为初始状态
            if (this.sequenceOrder === 'achievementascending') {
              this.sequenceOrder = 'null'
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
              }, 200)
            } else {
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) // 升序箭头高亮
              }, 200)
              if (this.$store.state.user.level === '1') {
                result.sort((a, b) => a.onYearRate - b.onYearRate)
              } else {
                result[0].children.sort((a, b) => a.onYearRate - b.onYearRate)
              }
              this.sequenceOrder = 'achievementascending' // 标志机构排序类型
            }
          } else if (flagData === 'descending') {
            if (this.sequenceOrder === 'achievementdescending') {
              this.sequenceOrder = 'null'
              setTimeout(() => {
                $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
              }, 200)
            } else {
              setTimeout(() => {
                $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'})
              }, 200)
              if (this.$store.state.user.level === '1') {
                result.sort((a, b) => b.onYearRate - a.onYearRate)
              } else {
                result[0].children.sort((a, b) => b.onYearRate - a.onYearRate)
              }
              this.sequenceOrder = 'achievementdescending'
            }
          } else {
            this.sequenceOrder = 'null'
            setTimeout(() => {
              $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
              $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
            }, 200)
          }
          break
        default:
          break
      }
      if (this.moreText === '收起') {
        result.unshift(this.totalRow)
      }
      this.showData = result
    },
    handleTheadAddClass (column) {
      // 判断找到当前列添加样式
      if (column.column.property === this.curThead) {
        return 'active-thead'
      }
    },
    getHomeInfo () {
      var url = '/simpapp/group/achievementRate'
      var postData = {
        'channelId': '0401',
        'classification': this.$store.state.entirety.kind,
        'date': this.dateData || '',
        'dateType': 3,
        'indexId': [
          'A0104-1004'
        ],
        'key': '',
        'level': this.$store.state.user.level,
        'orgId': this.$store.state.user.orgId
      }
      var obj = postAction(url, postData)
      obj.then(res => {
        // 判断总公司用户登录加入合计行，并讲系统合计行用数组slice方法返回新数组
        // slice(start,end)：方法可从已有数组中返回选定的元素，返回一个新数组,从start到end
        if (this.$store.state.user.orgId === '86') {
        // 系统合计行数据展示
          this.totalRow = res.data.provinceData[0]
          this.totalRow.id = '__total__row__'
          this.newTableData = res.data.provinceData.slice(1)
          this.tableData = res.data.provinceData.slice(1)
          this.showTabledata = res.data.provinceData.slice(1)
          this.showData = res.data.provinceData.slice(1)
        } else {
          this.newTableData = res.data.provinceData
          this.tableData = res.data.provinceData
          this.showTabledata = res.data.provinceData
          this.showData = res.data.provinceData
        }
        this.changeTable()
      })
    },
    childByValue (childValue, firstLevel, secondLevel, reachObj, compareObj, rateObj) {
      this.screenShow = childValue
      if (!firstLevel) { return }
      this.clearTable = false
      setTimeout(() => {
        this.clearTable = true
      }, 100)
      // childValue就是子组件传过来的值
      this.showNewTableData = []
      this.showData = []
      this.firstLevel = firstLevel
      this.secondLevel = secondLevel
      this.reachObj = reachObj
      this.compareObj = compareObj
      this.rateObj = rateObj
      if (firstLevel && firstLevel.length > 0 && firstLevel.length !== this.newTableData.length) {
        // 一级筛选 （确定后的）
        for (let i = 0; this.newTableData.length > i; i++) { // 一级
          var newTableDataS = this.newTableData[i].provincecomCode
          for (let n = 0; this.firstLevel.length > n; n++) { // 一级筛选
            var newFirstLevel = this.firstLevel[n].orgCode
            if (newFirstLevel === newTableDataS) {
              if (!this.showNewTableData) {
                this.showNewTableData = []
              }
              this.showNewTableData.push(this.newTableData[i])
            }
          }
        }
        this.showData = this.showNewTableData
      } else if (this.firstLevel.length === 0 || this.firstLevel.length === this.newTableData.length) {
        this.showData = this.newTableData
      }
      // if (this.reachObj.reachMin !== '' && this.reachObj.reachMax !== '') {
      //   this.showData = this.showData.filter((item) => {
      //     return item.achievementRate >= this.reachObj.reachMin && item.achievementRate <= this.reachObj.reachMax
      //   })
      // }
      // if (this.compareObj.compareMin !== '' && this.compareObj.compareMax !== '') {
      //   this.showData = this.showData.filter((item) => {
      //     return item.onYearRate >= this.compareObj.compareMin && item.onYearRate <= this.compareObj.compareMax
      //   })
      // }
      // if (this.rateObj.rateMin !== '' && this.rateObj.rateMax !== '') {
      //   this.showData = this.showData.filter((item) => {
      //     return item.completionRate >= this.rateObj.rateMin && item.completionRate <= this.rateObj.rateMax
      //   })
      // }
      if (this.reachObj) {
        if (this.reachObj.reachMin !== '') {
          this.showData = this.showData.filter((item) => {
            return item.achievementRate >= this.reachObj.reachMin
          })
        }
        if (this.reachObj.reachMax !== '') {
          this.showData = this.showData.filter((item) => {
            return item.achievementRate <= this.reachObj.reachMax
          })
        }
        if (this.reachObj.reachMin !== '' && this.reachObj.reachMax !== '') {
          this.showData = this.showData.filter((item) => {
            return item.achievementRate >= this.reachObj.reachMin && item.achievementRate <= this.reachObj.reachMax
          })
        }
      }
      if (this.compareObj) {
        if (this.compareObj.compareMin !== '') {
          this.showData = this.showData.filter((item) => {
            return item.onYearRate >= this.compareObj.compareMin
          })
        }
        if (this.compareObj.compareMax !== '') {
          this.showData = this.showData.filter((item) => {
            return item.onYearRate <= this.compareObj.compareMax
          })
        }
        if (this.compareObj.compareMin !== '' && this.compareObj.compareMax !== '') {
          this.showData = this.showData.filter((item) => {
            return item.onYearRate >= this.compareObj.compareMin && item.onYearRate <= this.compareObj.compareMax
          })
        }
      }
      if (this.rateObj) {
        if (this.rateObj.rateMin !== '') {
          this.showData = this.showData.filter((item) => {
            return item.completionRate >= this.rateObj.rateMin
          })
        }
        if (this.rateObj.rateMax !== '') {
          this.showData = this.showData.filter((item) => {
            return item.completionRate <= this.rateObj.rateMax
          })
        }
        if (this.rateObj.rateMin !== '' && this.rateObj.rateMax !== '') {
          this.showData = this.showData.filter((item) => {
            return item.completionRate >= this.rateObj.rateMin && item.completionRate <= this.rateObj.rateMax
          })
        }
      }
      if (this.showData.length > 5) {
        this.countFlag = true
      } else {
        this.countFlag = false
      }
    },
    showPopup () {
      this.screenShow = true
    },
    showMore () {
      if (this.showData.length > 5) {
        this.countFlag = true
        if (this.moreFlag) {
          this.isMore = true
          this.notmore = false
          this.chaerShow = false
          this.moreText = '收起'
          if (this.$store.state.user.orgId === '86') {
            this.showData.unshift(this.totalRow)
          }
          this.$emit('chaerShowClick', false)
          this.popHeight = document.documentElement.clientHeight - 40
          this.moreFlag = !this.moreFlag
        } else {
          this.isMore = false
          this.notmore = true
          this.chaerShow = true
          this.moreText = '查看更多'
          if (this.$store.state.user.orgId === '86') {
            this.showData.shift()
          }
          this.$emit('chaerShowClick', true)
          this.popHeight = ''
          this.moreFlag = !this.moreFlag
        }
      } else {
        this.countFlag = false
      }
    },
    changeType (index) {
      this.type = index
      this.changeTable()
    },
    changeTable () {
      this.moreText = '查看更多'
      if (this.showTabledata.length > 5) {
        this.countFlag = true
      } else {
        this.countFlag = false
      }
      // 排序
      for (let i = 0; i < this.tableData.length; i++) {
        this.showTabledata[i].hasChildren = false
        if (this.tableData[i].rankDiff === null || this.tableData[i].rankDiff === 0) {
          this.showTabledata[i].flag = 3
        } else {
          if (this.tableData[i].rankDiff < 0) {
            this.showTabledata[i].rankDiff = Math.abs(this.showTabledata[i].rankDiff)
            this.showTabledata[i].flag = 1
          } else {
            this.showTabledata[i].rankDiff = Math.abs(this.showTabledata[i].rankDiff)
            this.showTabledata[i].flag = 2
          }
        }
      }
    }
  },
  mounted () {
    this.nameData = {
      achievementName: '实际',
      achievementUnit: '%',
      comparedWithName: '同比',
      comparedWithUnit: 'pt'
    }
    this.getHomeInfo()
  },
  computed: {
    getChannel () {
      return this.$store.state.entirety.channel
    },
    getTime () {
      return this.$store.state.entirety.time
    },
    getQuota () {
      return this.$store.state.entirety.quota
    }
  },
  watch: {
    showData () {
      this.key = this.key + 1
    },
    getChannel () {
      this.$nextTick(() => {
        this.clearTable = false
        setTimeout(() => {
          this.clearTable = true
        }, 100)
        this.getHomeInfo()
      })
    },
    getTime () {
      this.$nextTick(() => {
        if (this.timeIndex === 3 && this.showData) { // 判断表格知识图标出现状态
          this.rightImg = true
        } else {
          this.rightImg = false
        }
        this.clearTable = false
        setTimeout(() => {
          this.clearTable = true
        }, 100)
        this.getHomeInfo()
      })
    },
    getQuota () {
      this.$nextTick(() => {
        this.clearTable = false
        setTimeout(() => {
          this.clearTable = true
        }, 100)
        this.getHomeInfo()
      })
    },
    dateData () {
      this.$nextTick(() => {
        this.clearTable = false
        setTimeout(() => {
          this.clearTable = true
        }, 100)
        this.getHomeInfo()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>>table.el-table__header{
    width: 100%;
  }
  >>>table.el-table__body{
    width: 100%;
  }
  >>>.tableList5{
    max-height: 324px;
    overflow: hidden;
  }
  .table {
    position: relative;
  }
  .table-warpper{
    margin-top: 0.1rem;
    padding: 0px 15px;
    background: #fff;
  }
  .table-itme>>>.el-table__expand-icon{
    float : left;
  }
  .table-itme>>>td,.table-itme>>>th{
    border-right: none;
    text-align : center;
  }
  .table-itme>>>span.el-table__indent{
    padding-left : 0!important;
  }
  .table-itme>>>tr.el-table__row.el-table__row--level-1{
    background : #F9F9F9;
  }
  .table-itme>>>.el-table__expand-icon{
    margin-right: -25px;
  }
  // .table-itme>>>tr.el-table__row.el-table__row--level-1:nth-child(0) .cell{
  //   margin-right: 20px
  // }
  .table-itme>>>span.el-table__placeholder{ // 不同级别缩进相同(不分等级级别对齐)
    width : 0;
  }
  .table-itme>>>tr.el-table__row.el-table__row--level-2 {
      background: #eee;
  }
  .van-popup.van-popup--center{
    width : 90%;
    // height : 60%;
    border-radius : .06rem;
    background #fff;
  }
  .table-title,.table-icon{
    font-size: 0.18rem;
    font-weight: 600;
    height: 0.45rem;
    line-height: 0.45rem;
  }
  .table-icon{
    text-align : right;
  }
  .table-itme>>>.el-table__expanded-cell{
    padding: 0;
    padding-left: 48px;
  }
  .table-itme>>>.el-form--inline .el-form-item__content{
    padding-left: 4px;
    padding-right: 4px;
  }
  .table-itme>>>.cell{
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .table-itme>>>td.el-table__expanded-cell{
    background: #F9F9F9;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .demo-table-expand{
    display: flex;
  }
  .more{
    line-height:.4rem;
    text-align: center;
    color:#3399FF;
    background: #ffffff;
    font-size: .14rem
  }
  .buttonChange {
    font-size: 0;
    text-align: right;
    height: 0.45rem;
    line-height: 0.45rem;
  }

  .buttonChange button {
    height: 0.26rem;
    line-height: 0.26rem;
    border: none;
    margin: 0;
    font-size: 0;
    font-size: 0.14rem;
    padding: 0 15px;
    color: #39f;
    background: none;
    border: 1px solid #39f;
    border-radius: 0.02rem;
  }

  .timeButton button {
    border: 1px solid #F2F2F2;
    color: #999;
  }

  .buttonChange .choose {
    background: #3399FF;
    border: 1px solid #3399FF;
    color: #fff;
    border-radius: 0.02rem;
  }
  .table-itme span{
    color: #FB6E6C;
  }
  .table-itme label{
    font-weight:normal
  }
  .table-itme .down{
    color: #00C29E;
  }
  .updown img{
    width: .15rem
    height: .18rem
  }
  .fixTop{
    width:100%;
    height:100vh;
    position : fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:999999999;
  }
  >>>colgroup{
    overflow: hidden;
    display: none;
  }
  .rightImg{ //表格指示图标
    display: inline-block;
    position: absolute;
    top: 50%;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/TeamRateTable.vue